export default __webpack_public_path__ + "static/44aa-4ef0ae2bc2196ee57fc9ac3d452b0b0b.png";